import { actionCreatorFactory } from 'typescript-fsa'
import { Session } from '../../types'

const actionCreator = actionCreatorFactory()

export const receiveSession = actionCreator<Session>('receiveSession')
